var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container sub-sys" },
    [
      _c(
        "div",
        { staticClass: "common-header" },
        [
          _c("common-header", {
            attrs: {
              headerList: [
                { label: "系统管理", url: "" },
                { label: "子系统管理", url: "" }
              ]
            }
          })
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "sys-top",
          staticStyle: {
            background: "#fff",
            height: "93px",
            "border-bottom": "1px solid  #e8e8e8"
          }
        },
        [
          _c("search-form", {
            attrs: { formData: _vm.searchFormData, btnType: _vm.btnType },
            on: {
              searchForm: _vm.searchForm,
              addTable: _vm.addTable,
              resetForm: _vm.resetForm
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "sys-body" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading"
                }
              ],
              ref: "multipleTable",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                "tooltip-effect": "dark",
                height: _vm.tableheight,
                "row-key": "id",
                border: "",
                "highlight-current-row": "",
                "default-expand-all": false,
                "tree-props": { children: "children" }
              },
              on: {
                "header-dragend": _vm.headerdragend,
                "selection-change": _vm.handleSelectionChange
              }
            },
            [
              _c("template", { slot: "empty" }, [
                _c(
                  "div",
                  {
                    staticStyle: {
                      height: "100%",
                      width: "100%",
                      display: "flex",
                      "align-items": "center",
                      "justify-content": "center"
                    }
                  },
                  [
                    _c("no-data", {
                      attrs: { height: "400px", width: "400px" }
                    })
                  ],
                  1
                )
              ]),
              _c("el-table-column", {
                attrs: { type: "expand", width: "56px", align: "center" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(props) {
                        return props.row.systemCategory.length > 0
                          ? [
                              _c(
                                "el-table",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: { data: props.row.systemCategory },
                                  on: { "header-dragend": _vm.headerdragend }
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "systemType",
                                      label: "系统类型",
                                      "show-overflow-tooltip": "",
                                      width: "180"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(scope) {
                                            return [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("filterSystemType")(
                                                      scope.row.systemType,
                                                      _vm.systemtpyelist
                                                    )
                                                  )
                                                )
                                              ])
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "baseUrl",
                                      label: "系统域名",
                                      "min-width": "200"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(scope) {
                                            return [
                                              _c(
                                                "el-tooltip",
                                                {
                                                  staticClass: "item",
                                                  attrs: {
                                                    effect: "dark",
                                                    placement: "top"
                                                  }
                                                },
                                                [
                                                  _c("div", {
                                                    attrs: { slot: "content" },
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.ToBreak(
                                                          scope.row.baseUrl
                                                        )
                                                      )
                                                    },
                                                    slot: "content"
                                                  }),
                                                  _c(
                                                    "div",
                                                    { staticClass: "line" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          scope.row.baseUrl
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "systemCategoryStatus",
                                      "show-overflow-tooltip": "",
                                      width: "100",
                                      label: "系统状态"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(scope) {
                                            return [
                                              _c("span", {
                                                class:
                                                  scope.row
                                                    .systemCategoryStatus ==
                                                  "VALID"
                                                    ? "statusicon"
                                                    : "unstatusicon"
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "statustitle" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      scope.row
                                                        .systemCategoryStatus ==
                                                        "VALID"
                                                        ? "有效"
                                                        : "失效"
                                                    )
                                                  )
                                                ]
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  }),
                                  _c("el-table-column", {
                                    attrs: { label: "操作", width: "50" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function(scope) {
                                            return [
                                              _c(
                                                "el-popover",
                                                {
                                                  ref: "subsys-" + scope.row.id,
                                                  attrs: {
                                                    placement: "right",
                                                    width: "200",
                                                    trigger: "click",
                                                    "popper-class":
                                                      "table-popper"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "op-tips" },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "op-item",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.editsubSysFn(
                                                                scope,
                                                                true
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "operate-edit-icon",
                                                            {
                                                              staticClass:
                                                                "svgOperateIcon"
                                                            }
                                                          ),
                                                          _vm._v(" 编辑")
                                                        ],
                                                        1
                                                      ),
                                                      _c(
                                                        "el-popconfirm",
                                                        {
                                                          attrs: {
                                                            title:
                                                              "确定要删除子系统吗？"
                                                          },
                                                          on: {
                                                            onConfirm: function(
                                                              $event
                                                            ) {
                                                              return _vm.delsubSysFn(
                                                                scope,
                                                                true
                                                              )
                                                            },
                                                            onCancel: function(
                                                              $event
                                                            ) {
                                                              return _vm.delsubSysFn(
                                                                scope,
                                                                false
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "op-item",
                                                              attrs: {
                                                                slot:
                                                                  "reference"
                                                              },
                                                              slot: "reference"
                                                            },
                                                            [
                                                              _c("delIcon", {
                                                                staticClass:
                                                                  "svgOperateIcon"
                                                              }),
                                                              _vm._v("删除")
                                                            ],
                                                            1
                                                          )
                                                        ]
                                                      )
                                                    ],
                                                    1
                                                  ),
                                                  _c("operate", {
                                                    staticClass: "operate-icon",
                                                    attrs: {
                                                      slot: "reference"
                                                    },
                                                    slot: "reference"
                                                  })
                                                ],
                                                1
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  })
                                ],
                                1
                              )
                            ]
                          : undefined
                      }
                    }
                  ],
                  null,
                  true
                )
              }),
              _c("el-table-column", {
                attrs: { type: "selection", width: "50" }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "systemId",
                  label: "系统编号",
                  "min-width": "80",
                  "show-overflow-tooltip": ""
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: { effect: "dark", placement: "top" }
                          },
                          [
                            _c("div", {
                              attrs: { slot: "content" },
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.ToBreak(scope.row.systemId)
                                )
                              },
                              slot: "content"
                            }),
                            _c("div", { staticClass: "line" }, [
                              _vm._v(_vm._s(scope.row.systemId))
                            ])
                          ]
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "systemName",
                  label: "系统名称",
                  "min-width": "80",
                  "show-overflow-tooltip": ""
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: { effect: "dark", placement: "top" }
                          },
                          [
                            _c("div", {
                              attrs: { slot: "content" },
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.ToBreak(scope.row.systemName)
                                )
                              },
                              slot: "content"
                            }),
                            _c("div", { staticClass: "line" }, [
                              _vm._v(_vm._s(scope.row.systemName))
                            ])
                          ]
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "systemStatus",
                  label: "是否是公共系统",
                  "min-width": "80",
                  "show-overflow-tooltip": ""
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-tooltip",
                          {
                            staticClass: "item",
                            attrs: { effect: "dark", placement: "top" }
                          },
                          [
                            _c(
                              "div",
                              { attrs: { slot: "content" }, slot: "content" },
                              [
                                _vm._v(
                                  _vm._s(
                                    scope.row.isPublicResource === 0
                                      ? "否"
                                      : "是"
                                  )
                                )
                              ]
                            ),
                            _c("div", { staticClass: "line" }, [
                              _vm._v(
                                _vm._s(
                                  scope.row.isPublicResource === 0 ? "否" : "是"
                                )
                              )
                            ])
                          ]
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { label: "操作", width: "70", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-popover",
                          {
                            ref: "sys-" + scope.row.id,
                            attrs: {
                              placement: "right",
                              width: "200",
                              trigger: "click",
                              "popper-class": "table-popper"
                            }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "op-tips" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "op-item",
                                    on: {
                                      click: function($event) {
                                        return _vm.editSysFn(scope, true)
                                      }
                                    }
                                  },
                                  [
                                    _c("operate-edit-icon", {
                                      staticClass: "svgOperateIcon"
                                    }),
                                    _vm._v(" 编辑")
                                  ],
                                  1
                                ),
                                _c(
                                  "el-popconfirm",
                                  {
                                    attrs: { title: "确定要删除系统吗？" },
                                    on: {
                                      onConfirm: function($event) {
                                        return _vm.confirmdel(scope, true)
                                      },
                                      onCancel: function($event) {
                                        return _vm.confirmdel(scope, false)
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "op-item",
                                        attrs: { slot: "reference" },
                                        slot: "reference"
                                      },
                                      [
                                        _c("delIcon", {
                                          staticClass: "svgOperateIcon"
                                        }),
                                        _vm._v("删除")
                                      ],
                                      1
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "op-item",
                                    on: {
                                      click: function($event) {
                                        return _vm.addSubSysFn(scope, false)
                                      }
                                    }
                                  },
                                  [
                                    _c("operateAddIcon", {
                                      staticClass: "svgOperateIcon"
                                    }),
                                    _vm._v("新增子系统")
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "op-item ",
                                    on: {
                                      click: function($event) {
                                        return _vm.seeIdfaFn(scope)
                                      }
                                    }
                                  },
                                  [
                                    _c("operate-view-icon", {
                                      staticClass: "svgOperateIcon"
                                    }),
                                    _vm._v(" 查看系统唯一标识")
                                  ],
                                  1
                                )
                              ],
                              1
                            ),
                            _c("operate", {
                              staticClass: "operate-icon",
                              attrs: { slot: "reference" },
                              slot: "reference"
                            })
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            2
          )
        ],
        1
      ),
      _c("div", { staticClass: "footer-page" }, [
        _c("div", { staticClass: "footer-left" }, [
          _c("input", {
            staticClass: "btn btn-del",
            attrs: { type: "button", value: "删除" },
            on: { click: _vm.showdeldialog }
          })
        ]),
        _c(
          "div",
          { staticClass: "footer-right" },
          [
            _vm.pageshow
              ? _c("el-pagination", {
                  attrs: {
                    background: "",
                    layout: "total, sizes, prev, pager, next, jumper",
                    total: _vm.totalpages,
                    "hide-on-single-page": false,
                    "page-sizes": [10, 20, 50, 100, 1000, 2000],
                    "page-size": 10,
                    "current-page": _vm.systemlistparms.pageNum
                  },
                  on: {
                    "update:currentPage": function($event) {
                      return _vm.$set(_vm.systemlistparms, "pageNum", $event)
                    },
                    "update:current-page": function($event) {
                      return _vm.$set(_vm.systemlistparms, "pageNum", $event)
                    },
                    "size-change": _vm.handleSizeChange,
                    "current-change": _vm.handleCurrentChange
                  }
                })
              : _vm._e()
          ],
          1
        )
      ]),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "dialog_footer_btn",
          attrs: {
            width: "382px",
            title: "查看系统唯一标识",
            visible: _vm.showIdfa
          },
          on: {
            "update:visible": function($event) {
              _vm.showIdfa = $event
            }
          }
        },
        [
          _c("see-idfa", {
            attrs: { idfa: _vm.systemidfa },
            on: { cancelIdfaFn: _vm.cancelIdfaFn }
          })
        ],
        1
      ),
      _vm.showSubSysEdit
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              staticClass: "dialog_footer_btn",
              attrs: {
                width: "560px",
                title: _vm.ifSubSysEdit ? "编辑子系统" : "新增子系统",
                visible: _vm.showSubSysEdit
              },
              on: {
                "update:visible": function($event) {
                  _vm.showSubSysEdit = $event
                }
              }
            },
            [
              _c("sub-sys-edit", {
                attrs: {
                  ifSubSysEdit: _vm.ifSubSysEdit,
                  typelist: _vm.systemtpyelist,
                  subformSysdata: _vm.selectsystem
                },
                on: {
                  cancelSubSysEdit: _vm.cancelSubSysEditFn,
                  subSysEditSubmit: _vm.subSysEditSubmitFn
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm.showSysEdit
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              staticClass: "dialog_footer_btn",
              attrs: {
                width: "560px",
                title: _vm.ifSysEdit ? "编辑系统" : "新增系统",
                visible: _vm.showSysEdit
              },
              on: {
                "update:visible": function($event) {
                  _vm.showSysEdit = $event
                }
              }
            },
            [
              _c("sys-edit", {
                attrs: {
                  ifSysEdit: _vm.ifSysEdit,
                  formSysdata: _vm.operationitem
                },
                on: {
                  cancelSysEdit: _vm.cancelSysEditFn,
                  sysEditSubmit: _vm.sysEditSubmitFn
                }
              })
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "dialog_footer_btn",
          attrs: {
            width: "382px",
            title: "删除系统",
            visible: _vm.ifShowDelDialog
          },
          on: {
            "update:visible": function($event) {
              _vm.ifShowDelDialog = $event
            }
          }
        },
        [
          _c("del-dialog", {
            attrs: {
              tips1: "确定要删除所选系统吗？",
              tips2: "删除系统后无法恢复，是否要删除系统"
            },
            on: {
              cancle: function($event) {
                _vm.ifShowDelDialog = false
              },
              commit: _vm.delsystem
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }